import { InteractsWithDOM } from '@scripts/core/InteractsWithDOM.js';

export class ReadMore extends InteractsWithDOM {
    PREFIX = 'read-more';

    constructor (domElm, prefix = null) {
        super(domElm);

        if (prefix !== null) {
            this.PREFIX = prefix;
        }

        this.retrieveElements();
        this.addListeners();
        this.checkIfNeedsToggle();
    }

    retrieveElements () {
        this.textWrapper = this.domElm.querySelector(`.${this.PREFIX}__text-wrapper`);
        this.text = this.domElm.querySelector(`.${this.PREFIX}__text`);
        this.toggle = this.domElm.querySelector(`.${this.PREFIX}__toggle`);
    }

    addListeners () {
        this.toggle?.addEventListener('click', () => {
            this.toggleText();
        });
    }

    checkIfNeedsToggle () {
        // Vérifier si le texte dépasse la hauteur max
        const maxHeight = window.getComputedStyle(this.text).maxHeight;
        const actualHeight = this.text.scrollHeight;
        const maxHeightValue = parseInt(maxHeight);

        if (actualHeight <= maxHeightValue) {
            // Le texte ne dépasse pas, on cache le bouton
            this.toggle.style.display = 'none';
        }
    }

    toggleText () {
        const maxHeight = this.text.scrollHeight;
        this.domElm.style.setProperty('--max-height', maxHeight + 'px');

        this.text.classList.toggle('expanded');
        this.toggle.classList.toggle('expanded');

        // Mettre à jour l'aria-label
        const isExpanded = this.text.classList.contains('expanded');
        this.toggle.setAttribute('aria-label', isExpanded ? 'Afficher moins' : 'Afficher plus');
    }
}
